import React from "react";

import { useMsal } from "@azure/msal-react";
import { Button } from "@mui/material";
import { loginRequest } from "authConfig";

interface AzureLoginProps {
  setLoading: (value: boolean) => void;
}

export const AzureLogin: React.FC<AzureLoginProps> = ({ setLoading }) => {
  const { instance } = useMsal();

  // const getToken = async (): Promise<string | void> => {
  //   try {
  //     if (inProgress !== InteractionStatus.None) {
  //       return;
  //     }
  //     const accessTokenRequest = {
  //       scopes: ["user.read"],
  //       account: accounts[0],
  //     };
  //     const { accessToken } = await instance.acquireTokenSilent(
  //       accessTokenRequest
  //     );
  //     if (accessToken) {
  //       return accessToken;
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const createToken = async () => {
    try {
      setLoading(true);
      // const token = await getToken();

      // if (token) {
      //   return;
      // }

      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      sx={{
        borderRadius: "5px",
        textTransform: "none"
      }}
      variant="contained"
      onClick={createToken}
    >
      SSO Login
    </Button>
  );
};
